import { useQuery } from "@tanstack/react-query";
import { DispatchBoardQueueLoad, GetDispatchBoardQueueLoadRequest } from "app/data/city-delivery/dispatch-board/models";
import CityDeliveryDiaptchBoardService from "app/data/city-delivery/dispatch-board/cityDeliveryDiaptchBoardService";
import { QUERY_KEYS } from "app/data/common/queryKeys";

export const useGetDispatchBoardQueueLoad = (requestData: GetDispatchBoardQueueLoadRequest) => {
  const hasIdentifier =
    requestData?.terminalNumber &&
    (requestData?.picklistNumber != null || requestData?.manifestNumber != null);

  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    isFetched,
    refetch,
  } = useQuery({
    queryKey: [
      QUERY_KEYS.GET_DISPATCH_BOARD_QUEUE_LOAD,
      requestData?.terminalNumber,
      requestData?.picklistNumber,
      requestData?.manifestNumber,
    ],
    queryFn: async () => {
      if (!hasIdentifier) return undefined;
      const response = await CityDeliveryDiaptchBoardService.getInstance().getDispatchBoardQueueLoad(
        requestData
      );
      if (response?.ok && !response.ok()) {
        throw response;
      }
      return response?.data;
    },
    enabled: !!hasIdentifier,
    refetchOnMount: "always",
    refetchOnWindowFocus: false,
    retry: true,
  });

  const dispatchLoad: DispatchBoardQueueLoad | undefined =
    data?.load ??
    (data && typeof data === "object" && ("picklistNumber" in data || "manifestNumber" in data)
      ? (data as unknown as DispatchBoardQueueLoad)
      : undefined);

  return {
    dispatchLoad,
    isLoadingDispatchLoad: isLoading,
    isFetchingDispatchLoad: isFetching,
    isErrorDispatchLoad: isError,
    errorDispatchLoad: error,
    isFetchedDispatchLoad: isFetched,
    refetchDispatchLoad: refetch,
  };
};
